import { CompositeLayer, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";
import { linearScale } from "../singleLayer/renderLayerService";

export class AdministrativeDayPopLayer extends CompositeLayer {
    name = "xxx";
    componentName = "xxx";
    workspace = "";
    layerName = "";
    is3D = false;
    //domain = [615.8510131835938, 1661.35302734375, 14111.571191406223]
    domain = [150, 1000, 20000]
    range = [[255, 255, 153], [255, 204, 153], [255, 94, 94]]
    rangeEdges = [[204, 204, 0], [255, 153, 51], [153, 0, 0]]
    opacity = 100

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity
    }

    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)

        return [
            new MVTLayer({
                id: 'AdmninistrativeDayPopHover',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: 0,
                stroked: true,
                filled: true,
                //extruded: this.is3D,
                // wireframe: false,
                getLineColor: [0,0,0,0],
                getFillColor: [0,0,0,0],
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],
                visible: true,
                dataComparator: (a, b) => false
            }),
            new MVTLayer({
                id: 'AdmninistrativeDayPop',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                //extruded: this.is3D,
                // wireframe: false,
                getLineColor: f => linearScale(f.properties.day_population, this.domain, this.range),
                getFillColor: f => linearScale(f.properties.day_population, this.domain, this.range),
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],
                visible: zoom < 9.5,
                dataComparator: (a, b) => false
            }),
            new MVTLayer({
                id: 'AdmninistrativeDayPopEdges',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                //extruded: this.is3D,
                // wireframe: false,
                getLineColor: f => linearScale(f.properties.day_population, this.domain, this.rangeEdges),
                getFillColor: f => linearScale(f.properties.day_population, this.domain, this.range),
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],
                visible: zoom >= 9.5,
                dataComparator: (a, b) => false
            }),
            
            
        ]
    }
}